import { render, staticRenderFns } from "./ChangeUsername.vue?vue&type=template&id=0f97f553"
import script from "./ChangeUsername.vue?vue&type=script&lang=js"
export * from "./ChangeUsername.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports